import * as Yup from 'yup';

export default Yup.object().shape({
  plainPassword: Yup.string().min(7, 'Sorry, min. 7 characters.').required('Please, enter a password.'),
});
